module.exports = __webpack_public_path__ + "img/newsImg11-1.a34dccbb.png";